import React from 'react';

const MemoryPalaceMap = ({ narrativeCheckpoints, currentCheckpoint }) => {
  return (
    <div className="memory-palace-map-container">
      <svg className="memory-palace-map">
        {/* Draw dotted path lines */}
        {narrativeCheckpoints.map((checkpoint, index) => {
          if (index === narrativeCheckpoints.length - 1) return null;
          const nextCheckpoint = narrativeCheckpoints[index + 1];
          return (
            <line 
              key={`path-${index}`}
              x1={checkpoint.position.x}
              y1={checkpoint.position.y}
              x2={nextCheckpoint.position.x}
              y2={nextCheckpoint.position.y}
              className="dotted-path"
            />
          );
        })}
        
        {/* Draw checkpoints */}
        {narrativeCheckpoints.map((checkpoint, index) => (
          <circle
            key={`checkpoint-${index}`}
            cx={checkpoint.position.x}
            cy={checkpoint.position.y}
            r={5}
            className={`checkpoint ${index === currentCheckpoint ? 'active' : ''}`}
          />
        ))}
        
        {/* Animated character */}
        <circle
          cx={narrativeCheckpoints[currentCheckpoint].position.x}
          cy={narrativeCheckpoints[currentCheckpoint].position.y}
          r={10}
          className="character"
        />
      </svg>
    </div>
  );
};

export default MemoryPalaceMap; 